var firebase = require('../firebase');
var toastr = require('toastr');

var { fbDb } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	loadSettingsSuccess: function(settings) {
		return {
			type: "LOAD_SETTINGS_SUCCESS",
			payload: settings
		};
	},

	updateSettingSuccess: function(setting) {
		return {
			type: "UPDATE_SETTING_SUCCESS",
			payload: setting
		};
	},

	unloadSettings: function() {
		return {
			type: "UNLOAD_SETTINGS"
		}
	},

	set(key, value) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`settings/${key}`)
			.set(value, error => error ? reject(error) : resolve());
		});
	},

	getKmMark: function(kmMax) {
		return 0;
	},

	unwrapKmPrice: function(settings) {
		return 0;
	},

	unwrapKmPriceNight: function(settings) {
		return 0;
	},

	unwrapKmPriceUpd: function(settings) {
		return 0;
	},

	unwrapKmPriceNightUpd: function(settings) {
		return 0;
	},

	loadSettings: function() {
		var me = this;

		return function(dispatch) {
			var ref = fbDb.ref('settings');

			ref.once('value', (snap) => {
				var settings = snap.val(), 
					kmPrice = me.unwrapKmPrice(settings),
					kmPriceNight = me.unwrapKmPriceNight(settings);

				dispatch(me.loadSettingsSuccess(Object.assign(
					{}, settings, {kmPrice: kmPrice, kmPriceNight: kmPriceNight})
				));
			});

			me._unsubscribe = () => ref.off();
		}
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadSettings());
		};
	},

	updateSetting: function(key, data) {
		var me = this;

		return function(dispatch) {
			me.set(key, data)
			.catch(() => {
				toastr.error('Ocorreu um erro ao atualizar o registro.');
			})
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/pushActions.js